import type { Lang } from '../store';
import { tr } from '../i18n';

export function shellHeader(lang: Lang): string {
  const L = tr(lang);
  return /* html */ `
    <header class="sq-header">
      <div class="sq-header-spacer"></div>
      <div class="sq-lang">
        <button data-lang="ro" class="${lang === 'ro' ? 'is-active' : ''}">${L.lang_ro}</button>
        <button data-lang="en" class="${lang === 'en' ? 'is-active' : ''}">${L.lang_en}</button>
      </div>
    </header>
  `;
}

export function brandLockup(): string {
  return /* html */ `
    <div class="sq-brand" aria-label="Sniff Quest">
      <img src="/sniffquest-logo.png?v=1" alt="Sniff Quest" class="sq-brand-img" width="720" height="143" />
    </div>
  `;
}

export function shellFooter(lang: Lang): string {
  const L = tr(lang);
  return /* html */ `
    <footer class="sq-footer">
      <div class="sq-footer-inner">
        <div class="sq-partners">
          <span class="label">${L.powered_by}</span>
          <strong>Sniffary</strong>
          <span class="sep">×</span>
          <strong>Boopr</strong>
          <span class="sep">×</span>
          <strong>Mash</strong>
          <span class="sep">×</span>
          <strong>Abry's Treats</strong>
        </div>
        <div class="sq-footer-note">
          ${L.note}
        </div>
        <div class="sq-footer-legal">
          <a href="/legal/regulament" target="_blank" rel="noopener">Regulament</a>
          <span class="sq-footer-sep">·</span>
          <a href="/legal/termeni" target="_blank" rel="noopener">Termeni</a>
          <span class="sq-footer-sep">·</span>
          <a href="/legal/confidentialitate" target="_blank" rel="noopener">Confidențialitate</a>
          <span class="sq-footer-sep">·</span>
          <a href="/admin/" class="sq-footer-admin">admin</a>
        </div>
      </div>
    </footer>
  `;
}
